// 组件
import { QuestionCircleOutlined } from "@ant-design/icons";
import { ProTooltip } from "../../antd";
// 方法
import { useLayoutContext } from '../../PageLayout/context/LayoutContext';
// 常量
import styles from './tableToolbar.module.less';

/** 帮助文档 */
const HelpLink = () => {
  const { menuHelp, } = useLayoutContext();
  const pathname = window.__POWERED_BY_WUJIE__ ? window.parent.location.pathname : window.location.pathname;
  
  return menuHelp && menuHelp[pathname] ? (
    <span className="yb-table-head-icon" key='help'>
      <a href={menuHelp[pathname]} className={styles.helpLink} target='_blank'>
        <ProTooltip placement="top" title="帮助">
          <QuestionCircleOutlined />
        </ProTooltip>
      </a>
    </span>
  ) : null;
};

export default HelpLink;
